import * as superagent from "superagent";
import {config} from "../../config";
import {Card} from "../Card";
import {CardFactory} from "../CardFactory";
import {CurrencyDenominator} from "../CurrencyDenominator";
import {HandPosition} from "../HandPosition";
import {InfoModal} from "../InfoModal";
import {BlackjackAction} from "./BlackjackAction";
import {BlackjackHand} from "./serverResponseClasses/BlackjackHand";
import {BlackjackInfoForClient} from "./serverResponseClasses/BlackjackInfoForClient";
import {ServerResponse} from "./serverResponseClasses/ServerResponse";

export class ApiService {

    private readonly STEEM_ACCOUNT_NAME: string = "steemAccountName";
    private readonly STEEM_CONNECT_TOKEN: string = "steemConnectToken";
    private readonly KEYCHAIN_JWT: string = "keychainjwt";

    private steemAccountName: string;
    private steemConnectToken: string;
    private keychainJWT: string;

    constructor() {
    }

    public setGameState(blackjackAction: BlackjackAction, betCurrency: string): Promise<ServerResponse> {
        for (let i = 0; blackjackAction && blackjackAction.bets && i < blackjackAction.bets.length; i++) {
            blackjackAction.bets[i].betAmount = CurrencyDenominator.ToBase(blackjackAction.bets[i].getBetAmount());
        }

        return superagent
            .post(config.gameServerAddress + "/setGameState")
            .set(this.STEEM_ACCOUNT_NAME, this.steemAccountName)
            .set(this.STEEM_CONNECT_TOKEN, this.steemConnectToken)
            .set(this.KEYCHAIN_JWT, this.keychainJWT)
            .send({currencyType: betCurrency, blackjackAction})
            .then((res): any => {
                return this.deserializeServerResponse(res.body.data);
            }).catch((res) => {
                if (res.status === 402) {
                    InfoModal.open("You need more Hive to keep playing.",
                        "Make a quick deposit and go back to the game!", () => {
                            if (top && top.window) {
                                top.window.location.replace(config.pageAddress);
                            } else {
                                window.location.replace(config.pageAddress);
                            }
                        });
                    InfoModal.setActionButtonText("GO TO MAKING DEPOSIT");
                } else if (res.status === 500) {
                    // window.location.reload(false);
                }
            });
    }

    public initGame(steemAccountName: string,
                    steemConnectToken: string,
                    keychainJWT: string): Promise<ServerResponse> {
        return superagent
            .get(config.gameServerAddress + "/initGame")
            .set(this.STEEM_ACCOUNT_NAME, steemAccountName)
            .set(this.STEEM_CONNECT_TOKEN, steemConnectToken)
            .set(this.KEYCHAIN_JWT, keychainJWT)
            .send({})
            .then((res) => {
                this.steemAccountName = steemAccountName;
                this.steemConnectToken = steemConnectToken;
                this.keychainJWT = keychainJWT;
                return this.deserializeServerResponse(res.body.data);
            });
    }

    private deserializeServerResponse(rawServerResponse: any): ServerResponse {
        rawServerResponse.accountInfo.steemAmount =
            CurrencyDenominator.ToMain(rawServerResponse.accountInfo.steemAmount);

        if (!rawServerResponse.blackjackInfoForClient) {
            return new ServerResponse(rawServerResponse.accountInfo, null, rawServerResponse.sessionParam);
        }
        const dealerHand: BlackjackHand = new BlackjackHand(0, HandPosition.DEALER);
        let bjHand: BlackjackHand, rawBjHand: any;
        dealerHand.setCards(this.deserializeCardsArray(rawServerResponse.blackjackInfoForClient.dealerHand.cards));
        const blackjackHands: Array<BlackjackHand> = [];
        for (let i = 0; i < rawServerResponse.blackjackInfoForClient.blackjackHands.length; i++) {
            rawBjHand = rawServerResponse.blackjackInfoForClient.blackjackHands[i];
            bjHand = new BlackjackHand(
                CurrencyDenominator.ToMain(rawBjHand.betAmount), rawBjHand.handPosition, rawBjHand.splitOnePosition,
                rawBjHand.splitTwoPosition, rawBjHand.splitNumber);
            bjHand.setCards(this.deserializeCardsArray(rawBjHand.cards));
            if (rawBjHand.doubled) {
                bjHand.double();
            }
            if (rawBjHand.handInsured) {
                bjHand.insure();
            }
            blackjackHands.push(bjHand);
        }

        return new ServerResponse(rawServerResponse.accountInfo, new BlackjackInfoForClient(
                dealerHand, blackjackHands,
                rawServerResponse.blackjackInfoForClient.currentHandIndex,
                rawServerResponse.blackjackInfoForClient.insurancePhaseFinished,
                rawServerResponse.blackjackInfoForClient.currentInsuranceHandIndex,
                rawServerResponse.blackjackInfoForClient.playerActionsFinished,
                CurrencyDenominator.ToMain(rawServerResponse.blackjackInfoForClient.totalBet),
                CurrencyDenominator.ToMain(rawServerResponse.blackjackInfoForClient.totalWin)),
            rawServerResponse.sessionParam);
    }

    private deserializeCardsArray(rawCardsArray: Array<any>): Array<Card> {
        const cards: Array<Card> = [];
        for (let i = 0; i < rawCardsArray.length; i++) {
            cards.push(CardFactory.createCard(rawCardsArray[i].color, rawCardsArray[i].name));
        }
        return cards;
    }
}



// WEBPACK FOOTER //
// ./src/app/api/ApiService.ts